import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="user-menu"
export default class extends Controller {
  static targets = ["input"];

  connect() {}

  closeFromOutside({ target }) {
    if (this.element.contains(target)) return;
    this.close();
  }

  close() {
    this.inputTarget.checked = false;
  }
}
